module.exports = __webpack_public_path__ + "img/electronic_enabled_selected.88b0b429.svg";